import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_64vt8d44: FaireBrandEntity = {
  token: "b_64vt8d44",
  type: "brand",
  name: "Le Feu De L'eau",
  avatarUrl:
    "https://cdn.faire.com/fastly/9de2ad0da168a5cc89806ce02406ade3ab97187a98342c442203ffcca482e9fa.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/67c6886b0a73a31fd30841730be86c261d4b1811f8a11992a5658420bfec0786.png",
  logoUrl:
    "https://cdn.faire.com/fastly/9de2ad0da168a5cc89806ce02406ade3ab97187a98342c442203ffcca482e9fa.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/67c6886b0a73a31fd30841730be86c261d4b1811f8a11992a5658420bfec0786.png",
  location: "Glendale, CA, USA",
  minimumOrderDollars: 125,
  rating: 5,
  reviewCount: 13,
  isInsider: true,
  description:
    "Melding Fire + Water Since 1968. \nOur name comes from the alchemical process of making a Le Feu de L’Eau candle. Sculpted underwater entirely out of wax, this unique method takes precision, brilliance, and a little bit of magic to forge our one-of-a-kind candles.\n\nAt Le Feu De L'Eau, we are driven by our passion for crafting high-quality candles. We constantly strive for excellence by exclusively using the finest ingredients and materials. Sustainability is at the core of our values, which is why we maintain small-scale production, employ recycled packaging, repurpose scraps, and collaborate with local vendors.",
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:06:21.509Z",
    importedBy: "entity-db-cli",
  },
};
